import getConfig from "@/utils/getConfig";
import {ChallengeInfoResponse, ChallengesApi, Token} from "@devour/client";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {useQuery, keepPreviousData} from "@tanstack/react-query";


async function fetchChallenge(challengeId?: string, slug?: string, fullToken?: Token): Promise<ChallengeInfoResponse> {
    return new ChallengesApi(getConfig(fullToken)).getChallengesGetInfo({challengeId, slug});
}

function useChallengeQuery(challengeId?: string, slug?: string) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return {
        queryKey: [
            "challenge",
            challengeId,
            slug,
            fullToken?.id ?? "unauthenticated",
        ],
        queryFn: () => fetchChallenge(challengeId, slug, fullToken),
        staleTime: 30 * 60000,
        enabled: Boolean(challengeId || slug),
        // Keep showing previous data while fetching new data (prevents flash on auth change)
        placeholderData: keepPreviousData,
    } as const;
}

export function useGetChallenge(challengeId?: string, slug?: string) {
    return useQuery(useChallengeQuery(challengeId, slug));
}